// src/components/email/EmailTemplateCreate.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

function EmailTemplateCreate() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState('');
  const [asunto, setAsunto] = useState('');
  const [cuerpo, setCuerpo] = useState('');
  const [variables, setVariables] = useState([]);
  const [newVariable, setNewVariable] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddVariable = () => {
    if (newVariable && !variables.includes(newVariable)) {
      setVariables([...variables, newVariable]);
      setNewVariable('');
    }
  };

  const handleRemoveVariable = (varToRemove) => {
    setVariables(variables.filter(v => v !== varToRemove));
  };

  const handleInsertVariable = (variable) => {
    const textarea = document.getElementById('cuerpo-template');
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = cuerpo;
    const before = text.substring(0, start);
    const after = text.substring(end, text.length);
    setCuerpo(before + `{{${variable}}}` + after);
  };

  const handleGuardar = async () => {
    if (!nombre || !asunto || !cuerpo) {
      alert('Por favor completa todos los campos requeridos');
      return;
    }

    setLoading(true);
    try {
      await api.post('/email/plantillas', { nombre, asunto, cuerpo, variables });

      alert('✅ Plantilla creada exitosamente');
      navigate('/email/plantillas');
    } catch (error) {
      alert('Error: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>📄 Nueva Plantilla de Email</h1>
        <button onClick={() => navigate('/email/plantillas')} style={styles.btnSecondary}>
          Volver
        </button>
      </div>

      <div style={styles.grid}>
        {/* Formulario Principal */}
        <div style={styles.mainPanel}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>Información de la Plantilla</h2>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Nombre de Plantilla *</label>
              <input
                type="text"
                style={styles.input}
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                placeholder="Ej: Promoción Mensual"
                disabled={loading}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Asunto del Email *</label>
              <input
                type="text"
                style={styles.input}
                value={asunto}
                onChange={e => setAsunto(e.target.value)}
                placeholder="Ej: ¡Oferta Especial para {{nombre}}!"
                disabled={loading}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Cuerpo del Email (HTML) *</label>
              <div style={styles.variableButtons}>
                {variables.map(variable => (
                  <button
                    key={variable}
                    type="button"
                    onClick={() => handleInsertVariable(variable)}
                    style={styles.variableBtn}
                  >
                    {`{{${variable}}}`}
                  </button>
                ))}
              </div>
              <textarea
                id="cuerpo-template"
                style={styles.textarea}
                value={cuerpo}
                onChange={e => setCuerpo(e.target.value)}
                placeholder="<div><h2>Hola {{nombre}},</h2><p>{{contenido}}</p></div>"
                disabled={loading}
                rows="15"
              />
            </div>

            <div style={styles.actions}>
              <button
                onClick={handleGuardar}
                disabled={loading || !nombre || !asunto || !cuerpo}
                style={{
                  ...styles.btnPrimary,
                  opacity: (loading || !nombre || !asunto || !cuerpo) ? 0.5 : 1,
                  cursor: (loading || !nombre || !asunto || !cuerpo) ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Guardando...' : 'Guardar Plantilla'}
              </button>
              <button
                onClick={() => navigate('/email/plantillas')}
                style={styles.btnSecondary}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>

        {/* Panel Lateral - Variables */}
        <div style={styles.sidebar}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>Variables Dinámicas</h2>
            
            <div style={styles.addVariable}>
              <input
                type="text"
                style={styles.inputSmall}
                value={newVariable}
                onChange={e => setNewVariable(e.target.value)}
                placeholder="ej: nombre, empresa"
                onKeyPress={e => e.key === 'Enter' && handleAddVariable()}
                disabled={loading}
              />
              <button
                onClick={handleAddVariable}
                style={styles.btnAdd}
                disabled={!newVariable || loading}
              >
                +
              </button>
            </div>

            <div style={styles.variablesList}>
              {variables.length > 0 ? (
                variables.map(variable => (
                  <div key={variable} style={styles.variableItem}>
                    <code style={styles.variableCode}>{`{{${variable}}}`}</code>
                    <button
                      onClick={() => handleRemoveVariable(variable)}
                      style={styles.btnRemove}
                      disabled={loading}
                    >
                      ✕
                    </button>
                  </div>
                ))
              ) : (
                <p style={styles.noVariables}>No hay variables definidas</p>
              )}
            </div>

            <div style={styles.infoBox}>
              <h4 style={styles.infoTitle}>💡 Variables Comunes</h4>
              <ul style={styles.infoList}>
                <li><code>{`{{nombre}}`}</code> - Nombre del cliente</li>
                <li><code>{`{{empresa}}`}</code> - Empresa del cliente</li>
                <li><code>{`{{email}}`}</code> - Email del cliente</li>
                <li><code>{`{{fecha}}`}</code> - Fecha actual</li>
                <li><code>{`{{unsubscribe_url}}`}</code> - Link para darse de baja</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 ESTILOS
// ═══════════════════════════════════════════════════════════════════════════
const styles = {
  container: {
    minHeight: 'calc(100vh - 70px)',
    background: 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 50%, #f0f9ff 100%)',
    padding: '24px 32px',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0
  },
  btnSecondary: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
    color: 'white',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: '24px'
  },
  mainPanel: {
    minWidth: 0
  },
  sidebar: {
    minWidth: 0
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '20px',
    paddingBottom: '12px',
    borderBottom: '2px solid #e5e7eb'
  },
  formGroup: {
    marginBottom: '20px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '8px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    background: 'white',
    transition: 'all 0.2s',
    fontFamily: 'inherit',
    boxSizing: 'border-box'
  },
  inputSmall: {
    flex: 1,
    padding: '10px 12px',
    fontSize: '13px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    background: 'white',
    fontFamily: 'inherit'
  },
  textarea: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '13px',
    border: '2px solid #e5e7eb',
    borderRadius: '8px',
    background: 'white',
    fontFamily: 'monospace',
    lineHeight: '1.6',
    resize: 'vertical',
    boxSizing: 'border-box'
  },
  variableButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '12px'
  },
  variableBtn: {
    padding: '6px 12px',
    background: '#dbeafe',
    color: '#1e40af',
    border: 'none',
    borderRadius: '12px',
    fontSize: '12px',
    fontFamily: 'monospace',
    fontWeight: '600',
    cursor: 'pointer'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    paddingTop: '20px'
  },
  btnPrimary: {
    flex: 1,
    padding: '14px 24px',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  addVariable: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px'
  },
  btnAdd: {
    padding: '10px 16px',
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  variablesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '20px'
  },
  variableItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    background: '#f9fafb',
    borderRadius: '8px'
  },
  variableCode: {
    color: '#3b82f6',
    fontWeight: '600',
    fontFamily: 'monospace',
    fontSize: '13px'
  },
  btnRemove: {
    background: 'none',
    border: 'none',
    color: '#ef4444',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '4px 8px'
  },
  noVariables: {
    fontSize: '13px',
    color: '#9ca3af',
    fontStyle: 'italic',
    textAlign: 'center',
    padding: '20px'
  },
  infoBox: {
    padding: '16px',
    background: '#eff6ff',
    borderRadius: '8px',
    borderLeft: '4px solid #3b82f6'
  },
  infoTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#1e40af',
    marginBottom: '12px'
  },
  infoList: {
    margin: 0,
    paddingLeft: '20px',
    fontSize: '12px',
    color: '#1e40af',
    lineHeight: '2'
  }
};

export default EmailTemplateCreate;